// @flow

const groupBy = (
  options: OptionsMap,
  child: Object,
  identifier: string,
  addOptions: boolean = true
): OptionsMap => {
  const group = new Map<number, OptionMap>(options);

  if (!group.has(child[identifier])) {
    group.set(child[identifier], {
      ...child,
      ...(addOptions ? { options: new Map<number, OptionMap>() } : null),
    });
  }

  return group;
};

const toArray = (options: OptionsMap | OptionsArray): OptionsArray => {
  if (Array.isArray(options)) return options;

  return Array.from(options.values()).map((value) => ({
    id: value.id,
    name: value.name,
    ...(value.applied === undefined ? null : { applied: value.applied }),
    ...(value.options === undefined
      ? null
      : { options: toArray(value.options) }),
  }));
};

const adaptOptions = (
  variants: FacetVariant[],
  identifier: string
): OptionsMap => {
  // New = Facet -> Variant -> Style     -> Dimension -> Option
  // Old = Facet -> Style   -> Dimension -> Variant   -> Option

  // let stylesMap = new Map<number, OptionMap>();
  let stylesMap = new Map();

  variants.forEach((variant) => {
    variant.options.forEach((style) => {
      stylesMap = groupBy(stylesMap, style, identifier);

      style.options.forEach((dimension) => {
        const styleMap = stylesMap.get(style[identifier]) ?? {};
        styleMap.options = groupBy(styleMap.options, dimension, identifier);

        dimension.options.forEach((option) => {
          const dimensionMap =
            styleMap.options.get(dimension[identifier]) ?? {};
          dimensionMap.options = groupBy(
            dimensionMap.options,
            variant,
            identifier
          );

          const variantMap =
            dimensionMap.options.get(variant[identifier]) ?? {};
          variantMap.options = groupBy(
            variantMap.options,
            option,
            identifier,
            false
          );
        });
      });
    });
  });

  return stylesMap;
};

const adaptGrouping = (
  variants: FacetVariant[],
  identifier: string
): Array<any> => toArray(adaptOptions(variants, identifier));

export default adaptGrouping;
